import { api } from 'common';
import { Column } from 'material-table';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { INotificationType, IUserNotificationType } from 'common/src/types';
import { CustomMaterialTable } from 'components/CustomMaterialTable';

export default function Notifications() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const settings = useSelector(state => state.settingsdata.settings);
  const notificationdata = useSelector(state => state.notificationdata);
  const {
    sendNotification,
    editNotifications
  } = api;

  if (!settings) return;

  const columns: Column<IUserNotificationType>[] = [
    {
      field: 'devicetype',
      title: t('device_type'),
      lookup: { All: (t('all')), ANDROID: (t('android')), IOS: (t('ios')) },
    },
    {
      field: 'usertype',
      title: t('user_type'),
      lookup: { All: (t('all')), customer: t('customer'), driver: t('driver') },
    },
    {
      title: t('title'),
      field: 'title'
    },
    {
      title: t('body'),
      field: 'body'
    },
  ];

  return (
    <CustomMaterialTable
      columns={columns}
      title={"push_notification_title"}
      isLoading={notificationdata.loading}
      data={notificationdata.notifications ?? []}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              if (settings.AllowCriticalEditsAdmin) {
                if (newData.body && newData.devicetype && newData.title && newData.usertype) {
                  dispatch(sendNotification(newData));
                  dispatch(editNotifications(newData, "Add"));
                  resolve("");
                } else {
                  alert(t('no_details_error'));
                  reject();
                }
              } else {
                alert(t('demo_mode'));
                reject();
              }
            }, 600);
          }),
        onRowDelete: oldData =>
          new Promise(resolve => {
            setTimeout(() => {
              resolve("");
              dispatch(editNotifications(oldData, "Delete"));
            }, 600);
          }),
      }}
      actions={[
        () => ({
          icon: "send",
          tooltip: t("send_button_text"),
          onClick: (_, newData) => {
            const notification = Array.isArray(newData)
              ? (newData[0] as INotificationType)
              : (newData as INotificationType);

            if (notification.body && notification.devicetype && notification.title && notification.usertype) {
              dispatch(sendNotification(notification));
            }
          },
        }),
      ]}
    />
  );
}
